var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1190_14685)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#7F7F7F",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2862 15.9126C20.2862 18.1733 18.4536 20.0059 16.1929 20.0059C13.9322 20.0059 12.0996 18.1733 12.0996 15.9126C12.0996 13.652 13.9322 11.8193 16.1929 11.8193C18.4536 11.8193 20.2862 13.652 20.2862 15.9126ZM19.8252 20.1661C18.848 21.0015 17.5793 21.5059 16.1929 21.5059C13.1038 21.5059 10.5996 19.0017 10.5996 15.9126C10.5996 12.8235 13.1038 10.3193 16.1929 10.3193C19.282 10.3193 21.7862 12.8235 21.7862 15.9126C21.7862 17.0758 21.4312 18.156 20.8235 19.0509C20.8471 19.0694 20.8698 19.0895 20.8915 19.1112L24.1809 22.4006C24.4738 22.6935 24.4738 23.1684 24.1809 23.4612C23.888 23.7541 23.4132 23.7541 23.1203 23.4612L19.8308 20.1718C19.829 20.1699 19.8271 20.168 19.8252 20.1661Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1190_14685",
    x: -75,
    y: -75,
    width: 185,
    height: 185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 37.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1190_14685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1190_14685",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewButton);
export default __webpack_public_path__ + "static/media/view-button.b1488b11f4fdf5d5fb106223070388df.svg";
export { ForwardRef as ReactComponent };